import { useContext } from "react"
import { ArchiveListContext } from "../../providers/contexts/ArchiveListContext";

export const useArchiveList = () => {
    return useContext(ArchiveListContext);
}